import { cardContext } from '@context/card-context';
import CardHeaderEditProvider from '@context/card-header-edit/provider';
import { DEFAULT_CARD_COLOR, extractCardFields, extractCardMetadata } from '@modules/card-helpers';
import type { Card } from 'types';

import CardComponent from '../Card';
import styles from '../Card.module.scss';
import CardLoader from '../CardLoader';

interface StaticCardProps {
  loading?: boolean;
  exampleCard: Card;
  mode?: 'fit' | 'standalone';
}

export const StaticCard: React.FC<React.PropsWithChildren<StaticCardProps>> = ({
  loading = false,
  exampleCard,
  mode = 'standalone',
}) => {
  const cardMetadata = extractCardMetadata(exampleCard);
  const cardFields = extractCardFields(exampleCard);

  function notCalling() {
    // prop not doing anything
  }

  return (
    <cardContext.Provider
      value={{
        allFieldTypesLocked: false,
        cardId: cardMetadata?.cardId ?? '',
        canLock: false,
        cardColor: cardMetadata?.color ?? DEFAULT_CARD_COLOR,
        cardFields,
        cardFieldsDispatch: notCalling,
        colorLocked: false,
        layoutImagesLocked: false,
        lockedFields: [],
        lockedFieldTypes: [],
        qrCodeLocked: false,
        userId: cardMetadata?.userId ?? '',
        orgId: cardMetadata?.orgId,
        queueActionOnSave: notCalling,
        rollbackChanges: notCalling,
        saveChanges: notCalling,
        toggleColorLock: notCalling,
        toggleFieldLock: notCalling,
        toggleFieldTypeLock: notCalling,
        toggleLayoutImagesLocked: notCalling,
        toggleLockAllFieldTypes: notCalling,
        toggleQRCodeLock: notCalling,
        interactive: false,
      }}
    >
      <CardHeaderEditProvider>
        {loading && (
          <div className={styles['card-loader-container']} data-mode={mode}>
            <CardLoader mode={mode} />
          </div>
        )}
        {!loading && <CardComponent loading={false} editMode={false} mode={mode}></CardComponent>}
      </CardHeaderEditProvider>
    </cardContext.Provider>
  );
};
